import axios from 'axios';

const API = axios.create({
  baseURL: 'https://spe-backend-d62q.onrender.com/api',
  timeout: 10000,
});

export const fetchProducts  = (category) => API.get('/products', { params: category ? { category } : {} });
export const submitInquiry  = (data)     => API.post('/contact', data);
export const fetchInquiries = ()         => API.get('/contact');

export default API;
